var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useRolGetAll } from "../../../fnx/rol/rolGetAll";
import LocalStorageService from "../../../services/localStorage";
import { useEffect, useState } from "react";
import { updateUserRoles } from "../../../resources/helper/userHelper";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var useRoleUser = function (setSeeToast, setTrigger) {
    var _a = useState([]), rolList = _a[0], setRolList = _a[1];
    var clientId = useState(lsLogin.getUserLoginStored().clientId)[0];
    var _b = useState(false), loadingSaveRolPermissions = _b[0], setLoadingSaveRolPermissions = _b[1];
    var _c = useState(null), selectedUser = _c[0], setSelectedUser = _c[1];
    var _d = useState(false), openDrawerRoles = _d[0], setOpenDrawerRoles = _d[1];
    var _e = useState(false), openDrawerRolesEdit = _e[0], setOpenDrawerRolesEdit = _e[1];
    var _f = useState([]), rolsSelected = _f[0], setRolsSelected = _f[1];
    var _g = useState([]), availableItems = _g[0], setAvailableItems = _g[1];
    var _h = useState([]), assignedItems = _h[0], setAssignedItems = _h[1];
    var _j = useState([]), availableItemsFiltered = _j[0], setAvailableItemsFiltered = _j[1];
    var _k = useState([]), assignedItemsFiltered = _k[0], setAssignedItemsFiltered = _k[1];
    var _l = useState(""), availableSearch = _l[0], setAvailableSearch = _l[1];
    var _m = useState(""), assignedSearch = _m[0], setAssignedSearch = _m[1];
    var _o = useRolGetAll(true, clientId, 1, 20), responseRol = _o.responseRol, errorRol = _o.errorRol, loadingRol = _o.loadingRol;
    var handleAvailableItems = function () {
        setAvailableItems(rolList.map(function (item) { return ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        }); }));
        setAvailableItemsFiltered(rolList.map(function (item) { return ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        }); }));
    };
    var handleAssignedItems = function () {
        setAssignedItems(rolsSelected.map(function (item) { return ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        }); }));
        setAssignedItemsFiltered(rolsSelected.map(function (item) { return ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        }); }));
    };
    var onRoleMove = function (itemId, from, to) {
        if (from === "available" && to === "assigned") {
            var rol = availableItems.find(function (item) { return item.id === itemId; });
            if (rol) {
                //update assigned items
                var newAssignedItems = __spreadArray(__spreadArray([], assignedItems, true), [rol], false);
                setAssignedItems(newAssignedItems);
                setAssignedItemsFiltered(newAssignedItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(assignedSearch.toLowerCase()); }));
                //update available items
                var newAvailableItems = availableItems.filter(function (item) { return item.id !== itemId; });
                setAvailableItems(newAvailableItems);
                setAvailableItemsFiltered(newAvailableItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(availableSearch.toLowerCase()); }));
            }
        }
        else if (from === "assigned" && to === "available") {
            var rol = assignedItems.find(function (item) { return item.id === itemId; });
            if (rol) {
                //update available items
                var newAvailableItems = __spreadArray(__spreadArray([], availableItems, true), [rol], false);
                setAvailableItems(newAvailableItems);
                setAvailableItemsFiltered(newAvailableItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(availableSearch.toLowerCase()); }));
                //update assigned items
                var newAssignedItems = assignedItems.filter(function (item) { return item.id !== itemId; });
                setAssignedItems(newAssignedItems);
                setAssignedItemsFiltered(newAssignedItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(assignedSearch.toLowerCase()); }));
            }
        }
    };
    var onRoleDelete = function (itemId) {
        var rol = assignedItems.find(function (item) { return item.id === itemId; });
        if (rol) {
            //update available items
            var newAvailableItems = __spreadArray(__spreadArray([], availableItems, true), [rol], false);
            setAvailableItems(newAvailableItems);
            setAvailableItemsFiltered(newAvailableItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(availableSearch.toLowerCase()); }));
            //update assigned items
            var newAssignedItems = assignedItems.filter(function (item) { return item.id !== itemId; });
            setAssignedItems(newAssignedItems);
            setAssignedItemsFiltered(newAssignedItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(assignedSearch.toLowerCase()); }));
        }
    };
    var onSaveRolPermissions = function (roles) { return __awaiter(void 0, void 0, void 0, function () {
        var respnse, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("onSaveRolPermissions", roles);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoadingSaveRolPermissions(true);
                    return [4 /*yield*/, updateUserRoles((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id) || "", roles.map(function (item) { return item.id; }))];
                case 2:
                    respnse = _a.sent();
                    if (respnse.ok) {
                        setSeeToast({
                            show: true,
                            type: typeAlert.success,
                            message: "Roles actualizados correctamente"
                        });
                        setOpenDrawerRolesEdit(false);
                        setTrigger(true);
                    }
                    else {
                        setSeeToast({
                            show: true,
                            type: typeAlert.error,
                            message: "Error al actualizar los roles"
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    setSeeToast({
                        show: true,
                        type: typeAlert.error,
                        message: "Error al actualizar los roles"
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingSaveRolPermissions(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onAvailableSearchChange = function (value) {
        setAvailableSearch(value);
        setAvailableItemsFiltered(availableItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(value.toLowerCase()); }));
    };
    var onAssignedSearchChange = function (value) {
        setAssignedSearch(value);
        setAssignedItemsFiltered(assignedItems.filter(function (item) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(value.toLowerCase()); }));
    };
    useEffect(function () {
        var _a;
        if (responseRol && (responseRol === null || responseRol === void 0 ? void 0 : responseRol.data)) {
            setRolList((_a = responseRol === null || responseRol === void 0 ? void 0 : responseRol.data) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (__assign(__assign({}, item), { label: item.name, value: item.id })); }));
        }
    }, [responseRol]);
    useEffect(function () {
        console.log("selectedUser", selectedUser);
        if (selectedUser && selectedUser.roles) {
            setRolsSelected(selectedUser.roles);
            handleAvailableItems();
            handleAssignedItems();
        }
    }, [selectedUser]);
    return {
        rolList: rolList,
        loadingRol: loadingRol,
        errorRol: errorRol,
        selectedUser: selectedUser,
        setSelectedUser: setSelectedUser,
        openDrawerRoles: openDrawerRoles,
        setOpenDrawerRoles: setOpenDrawerRoles,
        rolsSelected: rolsSelected,
        openDrawerRolesEdit: openDrawerRolesEdit,
        setOpenDrawerRolesEdit: setOpenDrawerRolesEdit,
        availableItems: availableItems,
        assignedItems: assignedItems,
        availableItemsFiltered: availableItemsFiltered,
        assignedItemsFiltered: assignedItemsFiltered,
        availableSearch: availableSearch,
        assignedSearch: assignedSearch,
        loadingSaveRolPermissions: loadingSaveRolPermissions,
        onRoleMove: onRoleMove,
        onRoleDelete: onRoleDelete,
        onSaveRolPermissions: onSaveRolPermissions,
        onAvailableSearchChange: onAvailableSearchChange,
        onAssignedSearchChange: onAssignedSearchChange
    };
};
